<template>
  <div>
  {{post.company}}
<form-select2
  name="company"
  label="company"
  :form="post"
  :value="value"
  @change="(val) => $emit('input', val)"
  :options="drdata.companies"
  :config="{
        id: 'id',
        label: 'name',
        ajax: {
          paginated: false,
          url: genUrl('companies', null,  'search'),
          term: 'name',
        }
      }"
  :classes="['form-select-solid form-select-sm']"
  v-if="fieldname==='company'"
/>

<form-select2
      :disabled="!value.company"
      name="office"
      label="office"
      :form="post"
      :value="value"
      @change="(val) => $emit('input', val)"
      :options="drdata.office"
      :config="addr_search_config"
      :classes="['form-select-solid']"
      v-else-if="fieldname==='office'"
  />


  <form-select2
      name="title"
      label="Title"
      :form="post"
      :value="value"
      @change="(val) => $emit('input', val)"
      :options="drdata.title"
      :config="{
            id: 'id',
            label: 'title',
            ajax: {
              paginated: false,
              url: genUrl('user_title', null,  'get'),
              term: 'title',
            }
          }"
      :classes="['form-select-solid']"
      v-else-if="fieldname==='title'"
  />


<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="first_name" label="First Name" v-else-if="fieldname==='first_name'"/>

<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="last_name" label="Last Name" v-else-if="fieldname==='last_name'"/>

<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="direct_mobile" label="Mobile Phone" v-else-if="fieldname==='direct_mobile'"/>

<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="direct_phone" label="Office Phone" v-else-if="fieldname==='direct_phone'"/>

<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="email" label="Email" v-else-if="fieldname==='email'"/>

<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="association" label="Association" v-else-if="fieldname==='association'"/>

<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="job_title" label="Job title" v-else-if="fieldname==='job_title'"/>

<form-select2
  name="users"
  label="Relationship"
  :form="post"
  :template="userTemplate"
  :selection-template="userSelectionTemplate"
  :value="value"
  @change="(val) => $emit('input', val)"
  :options="users"
  :config="{
        id: 'id',
        label: 'email',
        multiple: true,
        ajax: {
          paginated: true,
          url: genUrl('users', null,  'search'),
          term: 'query',
        }
      }"
  :classes="['form-select-solid']"
   v-else-if="fieldname==='job_title'"
>
</form-select2>

<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="nick_name" label="Nick Name" v-else-if="fieldname==='nick_name'"/>
<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="suffixes" label="Suffixes" v-else-if="fieldname==='suffixes'"/>
<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="assistant_name" label="Assistant Name" v-else-if="fieldname==='assistant_name'"/>
<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="personal_email" label="Personal Email" v-else-if="fieldname==='personal_email'"/>
<form-input :value="value" @input="(val) => $emit('input', val)" :form="post" name="home_phone" label="Home Phone" v-else-if="fieldname==='home_phone'"/>


<div class="d-flex flex-column fv-row mb-2 flex-wrap" v-else-if="fieldname==='date_joined'">
    <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
      <slot name="labelText">Join Date</slot>
    </label>
    <slot>
      <date-picker :value="value" @input="(val) => $emit('input', val)" input-class="form-control" placeholder="Select Join Date"/>
    </slot>
</div>



<div class="d-flex flex-column fv-row mb-2 flex-wrap" v-else-if="fieldname==='date_left'">
    <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
      <slot name="labelText">Left Date</slot>
    </label>
    <slot>
      <date-picker :value="value" @input="(val) => $emit('input', val)" input-class="form-control" placeholder="Select Left Date"/>
    </slot>
</div>


<div class="d-flex flex-column fv-row mb-2 flex-wrap" v-else-if="fieldname==='dnc'">
  <form-switch :value="value" @input="(val) => $emit('input', val)" :form="post" name="dnc" label="DNC"/>
</div>

<div class="d-flex flex-column fv-row mb-2 flex-wrap" v-else-if="fieldname==='left_company'">
<form-switch :value="value" @input="(val) => $emit('input', val)" :form="post" name="left_company" label="Left Company"/>
</div>

<div class="d-flex flex-column fv-row mb-2 flex-wrap" v-else-if="fieldname==='withdrawn'">
<form-switch :value="value" @input="(val) => $emit('input', val)" :form="post" name="withdrawn" label="Withdrawn"/>
</div>

</div>
</template>

<script>
export default {
  props: {
    fieldname: {
  		default: 'company'
    },
    value: ''
  },
  data(){
    return {
      post: Form.make({}),
      drdata: {
        companies: [],
        country_codes: [],
        title: [],
        ownerships: [],
        office: [],
        project: null,
      },
    }
  },
  computed: {
    addr_search_config() {

      return {
        id: 'id',
        label: 'branch',
        ajax: {
          paginated: false,
          url: this.genUrl('office_address', null, 'get'),
          term: 'branch',
          params: {company: this.post.company}
        }
      }
    },
  },
}
</script>